import { useEffect, useState } from 'react';

import { 
  ColumnContainer,
  Subtitle,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableData
} from '../../../../styles/component.styles';

const InventoriesTable = ({ inventories = [], selectCurrentInventory = () => {} }) => {
  const [ showProductColumn, setShowProductColumn ] = useState(false);

  useEffect(() => {
    if(inventories.length > 0 && inventories.some(inv => !!inv.Product)) {
      setShowProductColumn(true);
    }
  }, []);

  return (
    <ColumnContainer>

      {inventories.length === 0 ? (
        <Subtitle>No Inventories to Display</Subtitle>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              {showProductColumn && (
                <TableHead>Product</TableHead>
              )}
              <TableHead>Sku</TableHead>
              <TableHead>Size</TableHead>
              <TableHead>Quantity</TableHead>
              <TableHead>Price</TableHead>
              <TableHead>Date Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {inventories.map((inventory, index) => {
              const formattedDate = new Date(inventory.createdAt).toLocaleDateString('en-us', {
                day: 'numeric',
                year: 'numeric',
                month: 'numeric',
              });

              return (
                <TableRow
                  key={index}
                  onClick={() => selectCurrentInventory(inventory.id)}
                  cursor={inventory?.Product ? '' : 'pointer'}
                >
                  {showProductColumn && (
                    <TableData>{inventory?.Product ? inventory.Product.name : ''}</TableData>
                  )}
                  <TableData>{inventory.sku}</TableData>
                  <TableData>{inventory.size}</TableData>
                  <TableData>{inventory.quantity}</TableData>
                  <TableData>${inventory.price / 100}</TableData>
                  <TableData>{formattedDate}</TableData>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </ColumnContainer>
  );
};

export default InventoriesTable;